import React, { useEffect, useState } from "react";
import Button from "modules/Common/Components/Button";
import styled from "styled-components";
import { useSelector } from "react-redux";
import Cross from "../../../../assets/img/icons/cross.svg";
import { closeExportPopup, exportListDetails } from "../Lists/actions";
import { RootState } from "store";
import { getQueryParam } from "utils";

const ExportPopupStyle = styled.div<{ open?: any }>`
  ${(props) => (props.open ? "display: block;" : "display: none;")}
  position: absolute;
  top: 30%;
  left: 35%;
  border-radius: 30px;
  background-color: #ffffff;
  width: 550px;
  height: 380px;
  z-index: 11;
  opacity: 1;
  box-shadow: 0px 0px 20px 1px grey;
  padding: 45px;
  h1 {
    font-size: 42px;
    font-family: "robotomedium";
    color: #5e7079;
  }
  .upper-text {
    font-family: "robotoregular";
    font-size: 20px;
    color: #5e7079;
  }
  .lower-text {
    font-family: "robotomedium";
    font-size: 20px;
    color: #5e7079;
  }
  .close-popup {
    cursor: pointer;
    float: right;
    margin-top: -25px;
    margin-right: -25px;
  }
`;

const Wrapper = styled.div<{ open?: boolean }>`
  ${(props) => (props.open ? "display: block;" : "display: none;")}
  width: 100vw;
  background-color: rgba(0, 0, 0, 0.5);
  /* opacity: 0.4; */
  position: fixed;
  height: 100vh;
  z-index: 10;
  top: 0;
  left: 0px;
`;

const ExportErrorWrapper = styled.div<{ open?: boolean }>`
  ${(props) => (props.open ? "display: block;" : "display: none;")}
  position: absolute;
  top: 40%;
  left: 40%;
  border-radius: 30px;
  background-color: #ffffff;
  width: 350px;
  height: 200px;
  z-index: 11;
  opacity: 1;
  padding: 45px;
  box-shadow: 0px 0px 20px 1px grey;
  h2 {
    font-size: 42px;
    font-family: "robotomedium";
    color: #5e7079;
  }
`;

interface IExportPopup {
  listId?: number;
  tabState?: string;
}

const ExportPopup: React.FC<IExportPopup> = (props: IExportPopup) => {
  const { listId, tabState } = props;
  const showExportPopup = useSelector((state: RootState) => state.audienceLists.showExportPopup);
  const showExportPopupError = useSelector((state: RootState) => state.audienceLists.showExportPopupError);
  const exportEmail = useSelector((state: RootState) => state.user.userData.userEmail);
  const listAudienceFilters = useSelector((state: RootState) => state.audienceLists.listAudienceFilters);
  const peopleAudienceFilters = useSelector((state: RootState) => state.peopleAudience.peopleAudienceFilters);
  const searchTermPeople = useSelector((state: RootState) => state.peopleAudience.searchTermPeople);
  const searchTermListContacts = useSelector(
    (state: RootState) => state.audienceListDetails.searchTermListDetails
  );

  useEffect(() => {
    const bodyElement = (document.getElementsByTagName("body") as HTMLCollectionOf<HTMLElement>)[0];
    if (showExportPopup || showExportPopupError) {
      window.scrollTo(0, 0);
      bodyElement.classList.add("overlay-nav-without-scroll");
    } else {
      bodyElement.classList.remove("overlay-nav-without-scroll");
    }
  }, [showExportPopup, showExportPopupError]);
  return (
    <>
      <Wrapper open={showExportPopup || showExportPopupError} onClick={closeExportPopup}></Wrapper>
      <ExportPopupStyle open={showExportPopup} {...props}>
        <span className="close-popup" onClick={closeExportPopup}>
          <img src={Cross} alt="x" />
        </span>
        <h1>Export Audience</h1>
        <p className="upper-text">An email has been sent to “{exportEmail}” with the download link</p>
        <p className="lower-text">
          If you don't receive the email within 5 minutes, please check your SPAM folder as well
        </p>
        <div>
          <Button
            value={"Resend Email"}
            onClick={() => {
              if (listId) {
                if (tabState === undefined) {
                  exportListDetails(
                    {
                      export: true,
                      ...listAudienceFilters,
                      searchTermListContacts: searchTermListContacts,
                    },
                    listId
                  );
                } else {
                  exportListDetails(
                    {
                      export: true,
                      profiled: tabState === "profiled" ? "1" : "0",
                      ...listAudienceFilters,
                      searchTermListContacts: searchTermListContacts,
                    },
                    listId
                  );
                }
              } else {
                exportListDetails({
                  export: true,
                  searchTermPeople: searchTermPeople,
                  profiled: tabState === "all" ? "-1" : tabState === "profiled" ? "1" : "0",
                  ...peopleAudienceFilters,
                  ...(getQueryParam("email_id") ? { emailId: getQueryParam("email_id") } : {}),
                });
              }
            }}
          />
        </div>
      </ExportPopupStyle>
      <ExportErrorWrapper open={showExportPopupError}>
        <h2>Something went wrong</h2>
      </ExportErrorWrapper>
    </>
  );
};
export default ExportPopup;
